import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import './ArticleDetail.css';

interface Article {
  titulo: string;
  autor: string;
  conteudo: string;
  data: any;
  imagens?: string[];
}

const ArticleDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [article, setArticle] = useState<Article | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticle = async () => {
      if (id) {
        try {
          const docRef = doc(db, 'articles', id);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            setArticle(docSnap.data() as Article);
          }
        } catch (err) {
          console.error("Erro ao buscar artigo:", err);
        }
      }
      setLoading(false);
    };
    fetchArticle();
  }, [id]);

  if (loading) return <div className="container loading-detail"><p>Buscando conteúdo...</p></div>;
  if (!article) return <div className="container error-detail"><p>Artigo não encontrado.</p><Link to="/publicacoes" className="btn btn-primary">Voltar para todas as publicações</Link></div>;

  return (
    <div className="article-detail-page container">
      <Link to="/publicacoes" className="back-link">&larr; Voltar para todas as publicações</Link>
      
      <article className="full-article">
        <header className="article-header">
          <h1>{article.titulo}</h1>
          <div className="article-meta">
            <span className="meta-author">Por: {article.autor}</span>
            <span className="meta-date">
              {article.data?.seconds 
                ? new Date(article.data.seconds * 1000).toLocaleDateString('pt-BR') 
                : new Date().toLocaleDateString('pt-BR')}
            </span>
          </div>
        </header>

        {/* Imagen destacada (portada) si existe */}
        {article.imagens && article.imagens.length > 0 && (
          <div className="featured-article-image">
            <img src={article.imagens[0]} alt={article.titulo} />
          </div>
        )}

        {/* Contenido HTML enriquecido */}
        <div 
          className="article-body rich-text-content" 
          dangerouslySetInnerHTML={{ __html: article.conteudo }} 
        />

        {/* Galería si hay más de una imagen */}
        {article.imagens && article.imagens.length > 1 && (
          <div className="article-gallery">
            <h3>Galeria de Imagens</h3>
            <div className="gallery-grid">
              {article.imagens.slice(1).map((img, idx) => (
                <div key={idx} className="gallery-item">
                  <img src={img} alt={`${article.titulo} - ${idx + 2}`} className="gallery-img" />
                </div>
              ))}
            </div>
          </div>
        )}
      </article>
    </div>
  );
};

export default ArticleDetail;
